// extracted by mini-css-extract-plugin
export var example = "styles-module--example--UhOOv";
export var examples = "styles-module--examples--PuZ33";
export var list = "styles-module--list--b13BV";
export var name = "styles-module--name--34lv9";
export var picture = "styles-module--picture--YzEA+";
export var title = "styles-module--title--HNWwM";